// src/CompanyRegister/Step4.js
import React, { useState } from "react";
import { ciudadesPeru } from "../Data/PeruDistricts";
import { toast } from "sonner";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

const Step4 = ({ onNext, onBack, formData }) => {
  const [operacionGeografica, setOperacionGeografica] = useState(
    formData?.operacionGeografica || []
  );

  const handleAddCity = (city) => {
    if (operacionGeografica.includes(city)) {
      setOperacionGeografica((prev) => prev.filter((item) => item !== city));
    } else {
      setOperacionGeografica((prev) => [...prev, city]);
    }
  };

  const handleNext = () => {
    if (operacionGeografica.length === 0) {
      toast.warning("Por favor selecciona al menos una zona de operación.");
      return;
    }
    onNext({ operacionGeografica });
  };

  const handleBack = () => {
    onBack({ operacionGeografica }); // Envía los datos actuales al componente padre
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <h3 className="text-xl font-semibold text-foreground">Paso 4: Zonas de Operación</h3>
        <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">
              ¿En qué ciudades tienes operaciones? Marca todas las opciones que
              apliquen.
            </label>
            <div className="flex flex-wrap gap-2">
              {ciudadesPeru.map((city) => (
                <button
                  key={city}
                  type="button"
                  onClick={() => handleAddCity(city)}
                  className={cn(
                    "rounded-md border border-border px-3 py-1.5 text-sm hover:bg-muted",
                    operacionGeografica.includes(city) && "border-primary bg-primary/10 text-primary"
                  )}
                >
                  {city}
                </button>
              ))}
            </div>
            <div className="mt-3 flex gap-2">
              <Button type="button" variant="outline" onClick={() => setOperacionGeografica([])}>
                Quitar Todas
              </Button>
              <Button type="button" variant="outline" onClick={() => setOperacionGeografica(ciudadesPeru)}>
                Seleccionar Todas
              </Button>
            </div>
          </div>

          <div className="flex justify-between">
            <Button type="button" variant="outline" onClick={handleBack}>
              Retroceder
            </Button>
            <Button type="button" onClick={handleNext}>
              Siguiente
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default Step4;
